import { Duration } from 'luxon';
export const DEFAULT_GUEST_LINKS_SORT = {
    by: 'createdAt',
    order: 'desc',
};
export const GUEST_LINK_PATH_RESOLUTION_STALE_TIME = Duration.fromObject({
    minutes: 5,
}).toMillis();
export const GUEST_LINKS_LIST_REFETCH_INTERVAL_MS = Duration.fromObject({
    minutes: 5,
}).toMillis();
export const GUEST_LINKS_LIST_MIN_REFETCH_DELAY_MS = Duration.fromObject({
    seconds: 1,
}).toMillis();
export const GUESTS_PAGE_SIZE = 25;
